import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getComments = createAsyncThunk(
  'comments/get',
  async ({ commentType, commentListId }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(
        `/comments?ref_type=${commentType}&ref_id=${commentListId}`
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const addComment = createAsyncThunk(
  // action type string
  'comments/addComment',
  // callback function
  async ({ commentType, commentListId, userId, newComment }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.post('comments', {
        ref_type: commentType,
        ref_id: commentListId,
        user_id: userId,
        text: newComment,
      });
      return result;
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);
